import { render, staticRenderFns } from "./ModalCambioCuentas.vue?vue&type=template&id=5bc2c0d8&scoped=true"
import script from "./ModalCambioCuentas.vue?vue&type=script&lang=js"
export * from "./ModalCambioCuentas.vue?vue&type=script&lang=js"
import style0 from "./ModalCambioCuentas.vue?vue&type=style&index=0&id=5bc2c0d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc2c0d8",
  null
  
)

export default component.exports